import React from "react";
import { CASES_TABLE } from "../../utils/constants";
import themePropTypes from "../theme-prop-types";

const CaseTable = ({ cases, components: { Button }, onView, settings }) => {
  if (cases.length === 0) {
    return <p>{CASES_TABLE.noneText}</p>;
  }
  return (
    <table className='case-list-web-sdk'>
      <thead>
        <tr>
          <th>Reference number</th>
          <th>Member</th>
          <th>Case type</th>
          <th>Date submitted</th>
          <th>Status</th>
          <th />
        </tr>
      </thead>
      <tbody>
        {cases.map(
          ({
            caseNumber,
            caseForPersonName,
            type,
            createdDate,
            caseStatus
          }) => {
            const date = new Date(createdDate);
            return (
              <tr key={caseNumber}>
                <td>{caseNumber}</td>
                <td>{caseForPersonName}</td>
                <td>{type}</td>
                <td>
                  {date.getMonth() + 1}/{date.getDate()}/{date.getFullYear()}
                </td>
                <td>{caseStatus}</td>
                <td className='websdk-px-4'>
                  <Button
                    label={settings.translations.view}
                    onClick={() => onView(caseNumber)}
                    ariaLabel={settings.translations.view_details_of_this_case.replace(
                      "%reference_number%",
                      caseNumber
                    )}
                  />
                </td>
              </tr>
            );
          }
        )}
      </tbody>
    </table>
  );
};

CaseTable.propTypes = themePropTypes.caseTable;

export default CaseTable;
